import { Box, useMantineTheme } from "@mantine/core";
import { useAtomValue } from "jotai";
import { useLocation } from "react-router-dom";

import Flex from "components/Flex";
import Text from "components/Text";

import { DigitalJourneyRoute } from "app/DigitalJourneyAppFlow/constants";
import { otherVehiclePointsOfImpactAtom, pointsOfImpactPhAtom } from "atoms/pointsOfImpactDigitalJourney";
import { sessionIdAtom } from "atoms/sessionId";
import { useClientTranslation } from "hooks/useClientTranslation";

import { POINT_OF_IMPACT_TRANSLATION_KEYS } from "./constants";
import { PointOfImpact } from "./types";

export const DJPointOfImpactList = () => {
  const { t } = useClientTranslation();
  const { pathname } = useLocation();
  const theme = useMantineTheme();
  const phVehicleSelectedPoints = useAtomValue(pointsOfImpactPhAtom);
  const otherVehicleSelectedPoints = useAtomValue(otherVehiclePointsOfImpactAtom);
  const sessionId = useAtomValue(sessionIdAtom);

  const route = pathname.replace(sessionId, ":session");
  const orderedList =
    route === DigitalJourneyRoute.DamageLocationPH
      ? phVehicleSelectedPoints
      : DigitalJourneyRoute.DamageLocationOther
      ? otherVehicleSelectedPoints
      : [];

  return (
    <>
      {!orderedList.length && (
        <Text sizeVariant="md">Indica il punto d&apos;urto, anche in assenza di danni visibili</Text>
      )}
      {Boolean(orderedList.length) && (
        <Flex component="ul" direction="row" gap={8} align="flex-start" style={{ flexWrap: "wrap" }}>
          {orderedList.map((pointOfImpact) => (
            <Box
              key={pointOfImpact}
              px={8}
              component="li"
              py={2}
              style={{
                background: theme.other.primary[5],
                borderRadius: "16px",
              }}
            >
              <Text weight={500} color={theme.other.primary[80]}>
                {t(POINT_OF_IMPACT_TRANSLATION_KEYS[pointOfImpact as PointOfImpact])}
              </Text>
            </Box>
          ))}
        </Flex>
      )}
    </>
  );
};
